var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKontaktChat48 = function SvgKontaktChat48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 18.7H16.5c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7H34c.4 0 .7.3.7.7-.1.4-.4.7-.7.7zM34 23.5H16.5c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7H34c.4 0 .7.3.7.7-.1.4-.4.7-.7.7zM25.8 28.4h-9.3c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7h9.3c.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 41.1c-.5 0-.9-.2-1.2-.5-.3-.3-.5-.8-.4-1.3l.5-6.3C8 30.6 5.7 26.9 5.7 22.5c0-7.7 8.5-13.7 19.4-13.7 10.9 0 19.4 6 19.4 13.7 0 7.7-8.5 13.7-19.4 13.7-.7 0-1.5 0-2.2-.1-.5 0-1 .1-1.4.3l-7.3 4.4c-.3.2-.6.3-.9.3zm.2-8.3-.5 6.6c0 .1 0 .2.1.3.1.1.3.2.4.1l7.3-4.4c.6-.4 1.4-.6 2.2-.5.7.1 1.4.1 2.1.1 10.1 0 18-5.4 18-12.3s-7.9-12.3-18-12.3-18 5.4-18 12.3c0 4 2.2 7.3 6.1 9.5.2 0 .3.3.3.6z"
  })));
};
export default SvgKontaktChat48;